export default __webpack_public_path__ + "static/media/pictureTwo.c6c15320.svg";